export const MOBILE_DEVICE_WIDTH = 1024;
export const MOBILE_DEVICE_HEADER_WIDTH = 1440;
export const MOBILE_DEVICE_WIDTH_SMALL = 340;

export const HORIZONTAL_SCROLL_CHANGE = 140;
